import PageBanner from 'components/Luxkit/Banners/PageBanner'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import useOfferList from 'hooks/Offers/useOfferList'
import React, { useMemo } from 'react'

function HotelSearchLowResults({ filters, numResults }: {filters: App.OfferListFilters; numResults: number}) {
  const baseFilters = useMemo<App.OfferListFilters>(() => ({
    ...filters,
    holidayTypes: [],
    locations: [],
    customerRatingGte: undefined,
    amenities: [],
    inclusions: [],
  }), [filters])

  const localOfferList = useOfferList(baseFilters)
  const offerCount = localOfferList.offerCount

  return (<>
    {offerCount && offerCount > numResults && <PageBanner
      description={<strong>See up to {offerCount - numResults} more results by adjusting your filters</strong>}
      kind="informational-primary"
      icon={<LineInfoCircleIcon />}
    />}
  </>
  )
}

export default HotelSearchLowResults
